<template>
	<div ref="page" class="downPage"
		:class="{mark_show: show}">
		<div class="header"
			:class="{header_s: scrollTop >= 40}">
			<div class="down" :style="{marginLeft: '1200px'}" @click.stop="downloadPC">下载客户端</div>
		</div>
		<div class="wrap">
			<img class="bg_img" src="../assets/download/1.jpg">
			<img class="bg_img" src="../assets/download/2.jpg">
			<div class="btn_wrap">
				<div class="down_btn" @click.stop="downloadPC">
					<img class="down_icon" src="../assets/download/down_icon.png">
					<div>下载客户端</div>
				</div>
				<div class="play_btn" @click.stop="downloadPC">立即秒玩</div>
			</div>
		</div>
		<div class="footer">
			<bky-footer :copyright="default_name" :showTop="false"></bky-footer>
		</div>
		<img class="float_img" src="../assets/downpage/float_img.png"
			@click.stop="show_recharge">
		<div v-if="show" class="mark">
			<div class="recharge_wrap no_conversion">
				<img class="close_icon" src="../assets/downpage/close.png"
					@click.stop="close_recharge">
				<div class="pro_header">海量时长低价购</div>
				<div class="wrap">
					<div class="title">
						<img class="icon" src="../assets/downpage/1.png">
						<div>请选择充值套餐</div>
					</div>
					<div class="product_wrap">
						<div class="item free_item">
							<div class="corner_mark">每日限量</div>
							<div class="name">免费1小时</div>
							<div class="tips"></div>
							<div class="price_wrap"><span>已领完</span></div>
						</div>
						<div v-for="(item, index) in products" :key="index"
							class="item" :class="{active_item: select_no == index}"
							@click.stop="handle_select(index)">
							<div class="corner_mark">{{item.corner_mark}}</div>
							<div class="name">{{name_format(item.coin_count)}}小时</div>
							<div class="tips">优惠价</div>
							<div class="price_wrap">
								<div class="price">￥<span>{{item.product_price}}</span></div>
								<div class="original_price">￥{{item.original_price}}</div>
							</div>
						</div>
					</div>
					<div class="title">
						<img class="icon" src="../assets/downpage/2.png">
						<div>输入充值手机号</div>
					</div>
					<div class="form_wrap">
						<div class="login_form">
							<div class="form_item">
								<div class="dot">*</div>
								<input ref="phone" class="input" type="tel" v-model="phone"
									maxlength="11" placeholder="请输入你的手机号">
							</div>
							<div class="form_item">
								<div class="dot">*</div>
								<input ref="code" class="input code" type="text" v-model="code"
									maxlength="4" placeholder="请输入验证码">
								<div class="code_btn"
									:class="{active_code: phone.length == 11 && can_get_code}"
									@click.stop="get_sms_code">{{code_text}}</div>
							</div>
						</div>
						<div class="get_pay_code" @click.stop="login_confirm">确定并获取支付二维码</div>
					</div>
					<div class="title">
						<img class="icon" src="../assets/downpage/3.png">
						<div>扫码支付</div>
					</div>
					<div class="pay_way_wrap">
						<div class="way_list">
							<div class="title">选择支付方式</div>
							<div class="way_item" :class="{active_way: pay_way == 'wxpay'}"
								@click.stop="handle_pay_way('wxpay')">
								<img class="pay_icon" src="../assets/recharge/wechat@2x.png">
								<div>微信</div>
							</div>
							<div class="way_item" :class="{active_way: pay_way == 'alipay'}"
								@click.stop="handle_pay_way('alipay')">
								<img class="pay_icon" src="../assets/recharge/alipay@2x.png">
								<div>支付宝</div>
							</div>
						</div>
						<div class="info_wrap">
							<div class="qr_wrap">
								<div v-if="is_expire" class="qr_mark" @click.stop="refresh_code">
									<img class="refresh" src="../assets/downpage/refresh.png">
								</div>
								<div class="_code_wrap" id="qrcode"></div>
							</div>
							<div class="info">
								<div class="info_title">实付金额：</div>
								<div class="price">￥{{select_item.product_price}}</div>
								<div class="info_tips">使用手机扫一扫支付</div>
							</div>
						</div>
					</div>
					<div class="recharge_footer">
						<div>联系客服</div>
						<img class="qq_icon" src="../assets/downpage/qq.png">
						<div class="qq">3478489544</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
import QRCode from 'qrcodejs2'
import {mapActions} from 'vuex'
import { JSEncrypt } from 'jsencrypt'
import BkyFooter from '@/components/footer';
import {Message} from 'element-ui';

document.title = "胖哒云游";

export default{
	components: {
		BkyFooter,
	},
	data(){
		return{
			activeItem:0,
			default_url: 'https://dl.tlhcxm.top/PC/pangda/pangdayunyou_pc_official.exe',
			url_list: {},
			pc_url: '',
			link_url: [
				'https://h5.tlhcxm.top/secret.html',
				'https://h5.tlhcxm.top/permissions.html'
			],
			default_name: '厦门同力合创网络科技有限公司深圳分公司 @版权所有',
			link_list: [],
			scrollTop: 0,
			qhclickid: '',
			bd_vid: '',
			show: false,
			products: [],
			select_no: 0,
			phone: '',
			code: '',
			code_text: '获取验证码',
			can_get_code: true,
			pay_way: 'alipay',
			token: '',
			timeTick: null,
			kind: 103,
			is_login: false,
			qr: null,
      public_key: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjs9W0qLWft3ZaaD1EoO0cczcfiRo5qOpNZgy265h1Sf2/u35u3Mh/D/sNj/0mS5nvY+/PRmmhOTxrPKhUKP8l9Ym4rB78Cod0M01nv8QXRnQTeZc7F6ApmVkFOi8IjxdhiVlbjyGoVO/qWAv3QmtXMTizfoBqMI3dHFmMzfI3BIxLoUDaxRqXpcSxrJAnaG4rzmfzhqpbGJX0dliNNJg4NKvDiTMn+YTsjmHkymFDBFPTZchToLcL7k9OQSnhlfNBgR/RYmllOdQAuo039oWCQqEa6Q29erSQ06LUE71P93XWkK829p0Be/WkX+6OZSpIfOu6YoJ+RCG8Y5UcDfYywIDAQAB',
			order_timer: null,
			order_index: 0,
			order_no: '',
			is_expire: true,
			old_phone: '',
			channel: ''
		}
	},
	computed: {
		select_item () {
			const item = this.products[this.select_no] || {}
			return item
		},
	},
	created() {
		const href = location.href
		if (href == 'https://bkypc.qiusanga.cn/index.html#/downloadP') {
			this.$router.push({
				name: 'downloadP',
				query: {
					channel: 'scb_official'
				}
			})
		}
		this.$utils.checkBrowser();
		const channel = this.$route.query.channel
		console.warn(channel, 'channel')
		this.channel = channel
		if (channel) this.set_is_channel(true)
		if (channel == 'baidu') {
			window._agl = window._agl || [];
			(function () {
				window._agl.push(
					['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
				);
				(function () {
						var agl = document.createElement('script');
						agl.type = 'text/javascript';
						agl.async = true;
						agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
						var s = document.getElementsByTagName('script')[0];
						s.parentNode.insertBefore(agl, s);
				})();
			})();
		}
		// this.get_channel_list(channel)
		window.addEventListener('scroll', () => {
			this.scrollTop = document.documentElement.scrollTop
		})
		const qhclickid = this.$utils.getQueryString('qhclickid')
		const bd_vid = this.$utils.getQueryString('bd_vid')
		console.warn(qhclickid, bd_vid)
		if (qhclickid) {
			this.qhclickid = qhclickid.split('#')[0]
		}
		if (bd_vid) {
			this.bd_vid = bd_vid.split('#')[0]
		}
		this.get_product_list()
		this.get_channel_config(channel)
	},
	methods:{
		...mapActions(['set_is_channel']),
		// 显示支付弹窗
		show_recharge () {
			this.show = true
			this.is_expire = true
		},
		// 关闭支付弹窗
		close_recharge () {
			this.show = false
			this.qr = null
			clearInterval(this.order_timer)
			clearInterval(this.timeTick)
		},
		// 刷新二维码
		refresh_code () {
			if (!this.is_login) {
				this.$refs.phone.focus()
				Message({type:'error', message: '请输入手机号并获取验证码后点击获取支付二维码'})
			} else {
				this.get_pay_url()
			}
		},
		// 获取验证码
    async getCode () {
			this.can_get_code = false
      const timestamp = parseInt(new Date().getTime() / 1000)
			const str = `kind=${this.kind}&phone=${this.phone}&platform=web&template_kind=0&timestamp=${timestamp}&type=1`
			const encryptor = new JSEncrypt()
			encryptor.setPublicKey(this.public_key)
			const sign = encryptor.encrypt(str)
      const params = {
        phone: this.phone,
        template_kind: 0,
				type: 1,
				platform: 'web',
				timestamp: timestamp,
				kind: this.kind,
				sign: sign
      }
			const url = 'api/v1/cloud_pc/sms_send_v2'
      const {code, msg} = await this.$req.post(url, params)
      if (code == 0) {
        // this.disabled = true
        this.$refs.code.focus()
        this.codeTick()
				Message({type:'success', message:'验证码发送成功'})
      } else {
				this.can_get_code = true
				Message({type:'warning', message: msg})
      }
    },
		// 设定验证码过期定时器
    codeTick () {
      let num = 60
      this.timeTick = setInterval(() => {
        if (num > 0) {
          if (num < 10) {
            num = '0' + num
          }
          this.code_text = `${num}S后过期`
          num--
        } else {
          this.code_text = '获取验证码'
          clearInterval(this.timeTick)
					this.can_get_code = true
        }
      }, 1000)
    },
		// 点击获取验证码
		get_sms_code () {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(this.phone)) {
				Message({type:'error', message: '请输入正确的手机号'})
      } else {
				if (!this.can_get_code) return false
        this.getCode()
      }
    },
		// 确认并获取二维码
		login_confirm () {
			if (this.is_login && this.phone == this.old_phone) {
				this.get_pay_url()
			} else {
				this.login()
			}
		},
    // 登录
    async login () {
			if (!this.phone) return Message({type:'error', message: '请输入正确的手机号'})
			if (!this.code) return Message({type:'error', message: '请输入正确的验证码'})
      const params = {
				phone: this.phone,
				code: this.code,
				kind: this.kind,
				platform: 'web',
				channel: this.channel || 'scb_official_2'
			}
			const url = 'api/v1/cloud_pc/app/login_phone'
      const {code, data, msg} = await this.$req.post(url, params)
      if (code === 0) {
				this.old_phone = this.phone
				this.is_login = true
				localStorage.setItem('login', JSON.stringify({
					token: data.token
				}))
				this.get_pay_url()
      } else {
				Message({type:'warning', message: msg})
      }
    },
		// 修改支付方式
		handle_pay_way (pay_way) {
			if (this.pay_way == pay_way) return
			this.pay_way = pay_way
			if (this.is_login) {
				this.get_pay_url()
			}
		},
		// 下单
    async get_pay_url () {
      if (this.pay_loading) return
      this.pay_loading = true
      clearTimeout(this.order_timer)
      const params = {
        terminal: 'WEB',
        channel: this.pay_way,
        method: 'qr_code',
        product_id: this.select_item.id
      }
			const url = 'api/v1/cloud_pc/app/pay'
      const {code, data} = await this.$req.post(url, params)
      console.warn(code, data)
      this.pay_loading = false
      if (code == 0) {
				this.is_expire = false
        this.order_no = data.order_no
        this.check_order()
        this.$nextTick(() => {
					this.create_code(data.url)
				})
      }
    },
		// 生成付款二维码
    create_code (url) {
      if (this.qr) {
        this.qr.makeCode(url)
      } else {
        this.qr = new QRCode('qrcode', {
          width: 110,
          height: 110, 
          text: url
        })
      }
    },
		// 支付回调
    async check_order () {
      console.warn('order_no', this.order_no)
      this.order_index = 0
      clearInterval(this.order_timer)
			const url = 'api/v1/cloud_pc/app/pay/query'
      this.order_timer = setInterval(async () => {
        const params = {
          out_trade_no: this.order_no,
        }
        const {code} = await this.$req.post(url, params)
        if (code != 0 && this.order_index == 60) {
          this.is_expire = true
					Message({type:'error', message: '支付失败'})
        } else if (code == 0) {
          clearInterval(this.order_timer)
          this.get_pay_url()
					Message({type:'success', message: '支付成功'})
        }
        this.order_index ++
      }, 3000);
    },
		// 获取套餐列表
		async get_product_list () {
			const params = {
        product_type: 0,
        first_type: 133
      }
			const url = 'api/v1/cloud_pc/app/product/list'
			const {code, data} = await this.$req.post(url, params)
			if (code == 0) {
				this.products = data
			}
		},
		// 套餐名字格式化
    name_format (coin_count) {
      if (coin_count) {
        return Math.round(coin_count / 5 / 60)
      }
    },
		// 选择套餐
		handle_select (index) {
			if (this.select_no == index) return
			this.select_no = index
			if (this.is_login) {
				this.get_pay_url()
			}
		},
		// 获取渠道配置文件
		get_channel_list (channel) {
			const url = 'https://dl.tlhcxm.top/PC/json/pc_promote_channel_packets.json'
			axios.get(url).then(res=>{
				if (res) {
					this.url_list = res
					const channel_info = this.url_list[channel]
					if (channel_info) {
						this.pc_url = channel_info.packet_url
						this.default_name = channel_info.copyright
					} else {
						this.pc_url = this.default_url
					}
				}
			})
		},
		// 获取配置
		get_channel_config (channel) {
			const url = 'api/v1/cloud_pc/get_channel_callback_config'
			axios.post(url, {channel}).then(({code, data}) => {
				if (code == 0) {
					if (data.url) {
						this.pc_url = data.url
						this.default_name = data.copyright
						console.warn(data.packet_url, 'packet_url')
					} else {
						this.get_channel_list(channel)
					}
				}
			})
		},
		// 下载
		downloadPC(){
			this.$utils.Burying({act:'downLoadWin',operating_system:'web'});
			window.open(this.pc_url)
			if (this.bd_vid || this.qhclickid) {
				const params = {
					channel: this.channel
				}
				if (this.bd_vid) {
					params.kind = 2
					params.data = JSON.stringify([
						{
							"logidUrl": location.href,
							"newType": 6
						}
					])
				} else if (this.qhclickid) {
					params.kind = 1
					params.data = JSON.stringify({
						data_industry: 'ocpc_ps_convert',
						data_detail: {
							qhclickid: this.qhclickid,
							event: 'SITEDOWNLOAD'
						}
					})
				}
				const url = 'api/v1/cloud_pc/app_download_click'
				this.$req.post(url, params).then(res => {
					console.warn(res)
				})
			}
		},
		// 跳转
		jump_link (index) {
			location.href = this.link_url[index]
		}
	}
}
</script>

<style lang="less" scoped>
@keyframes btn-animation {
	0% {
		transform: scale(0.9);
	}
	100% {
		transform: scale(1);
	}
}
.downPage{
	background-color: #000000;
	div {
		box-sizing: border-box;
	}
	img {
		display: block;
	}
	.header {
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1;
		.logo {
			height: 40px;
			width: auto;
		}
		.down {
			width: 140px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			font-size: 14px;
			border-radius: 20px;
			color: #CDEB67;
			border: 1px solid #CDEB67;
			cursor: pointer;
			animation: btn-animation 0.5s ease-out infinite alternate;
		}
	}
	.header_s {
		width: 100px;
		background-color: #000000;
	}
	.wrap {
		position: relative;
		.bg_img {
			width: 100%;
			height: auto;
		}
		.btn_wrap {
			position: absolute;
			width: 100%;
			// height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			top: 0;
			left: 0;
			padding-top: 21%;
			.down_btn, .play_btn {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 340px;
				height: 74px;
				border-radius: 39px;
				cursor: pointer;
				box-sizing: border-box;
				background-color: #CDEB67;
				font-size: 20px;
				font-weight: bold;
				animation: btn-animation 0.5s ease-out infinite alternate;
				.down_icon {
					width: 24px;
					height: 24px;
					margin-right: 10px;
				}
			}
			.play_btn {
				margin-top: 73%;
			}
		}
	}
	.float_img {
		width: 180px;
		height: 180px;
		position: fixed;
		right: 80px;
		bottom: 200px;
		cursor: pointer;
	}
	.mark {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 999;
		background-color: rgba(0, 0, 0, 0.85);
		display: flex;
		align-items: center;
		justify-content: center;
		.recharge_wrap {
			width: 658px;
			border-radius: 12px;
			color: #FFFFFF;
			overflow: hidden;
			position: relative;
			.close_icon {
				position: absolute;
				width: 24px;
				height: 24px;
				top: 18px;
				right: 24px;
				cursor: pointer;
			}
			.pro_header {
				height: 60px;
				font-size: 20px;
				line-height: 60px;
				padding-left: 22px;
				background-color: #2F2F2F;
			}
			.wrap {
				padding: 20px 28px 24px;
				background-color: #FFFFFF;
				.title {
					display: flex;
					align-items: center;
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 13px;
					color: rgba(0, 0, 0, 0.85);
					.icon {
						width: 22px;
						height: 22px;
						margin-right: 6px;
					}
				}
				.product_wrap {
					width: 630px;
					height: 155px;
					overflow-x: auto;
					display: flex;
					flex-wrap: nowrap;
					margin-bottom: 14px;
					.item {
						width: 140px;
						height: 140px;
						border-radius: 12px;
						margin-right: 14px;
						flex-shrink: 0;
						position: relative;
						text-align: center;
						padding-top: 26px;
						background-color: #F0F0F0;
						user-select: none;
						cursor: pointer;
						.corner_mark {
							font-size: 12px;
							color: #F6C470;
							position: absolute;
							right: 0;
							top: 0;
							min-width: 60px;
							height: 22px;
							text-align: center;
							line-height: 22px;
							background: linear-gradient(to right, #6B6B6B, #2F2F2F);
							border-radius: 0 12px 0 12px;
						}
						.name {
							font-size: 18px;
							color: #000000;
							font-weight: bold;
						}
						.tips {
							color: #785218;
							font-size: 14px;
							margin: 13px 0 4px;
							height: 19px;
						}
						.price_wrap {
							display: flex;
							align-items: flex-end;
							justify-content: center;
							span {
								font-size: 24px;
								color: #785218;
								font-weight: bold;
							}
							.price {
								font-size: 14px;
								color: #785218;
							}
							.original_price {
								color: #989898;
								font-size: 14px;
								margin-bottom: 2px;
							}
						}
					}
					.free_item {
						cursor: not-allowed;
					}
					.active_item {
						background: linear-gradient(to right, #F3E6C3, #DBB676);
					}
				}
				.form_wrap {
					display: flex;
					align-items: center;
					font-size: 14px;
					.login_form {
						.form_item {
							display: flex;
							align-items: center;
							margin-bottom: 12px;
							.dot {
								font-size: 20px;
								color: #D70030;
								margin-right: 10px;
							}
							.input {
								width: 340px;
								height: 44px;
								border-radius: 8px;
								font-size: 14px;
								padding-left: 14px;
								border: 1px solid #E0E0E0;
							}
							.code {
								width: 210px;
							}
							.code_btn {
								width: 120px;
								height: 44px;
								border-radius: 8px;
								color: #000000;
								text-align: center;
								line-height: 44px;
								margin-left: 10px;
								background-color: #F0F0F0;
								cursor: pointer;
							}
							.active_code {
								background-color: #CDEB67;
							}
						}
					}
					.get_pay_code {
						width: 184px;
						height: 50px;
						color: #000000;
						text-align: center;
						margin-left: 30px;
						line-height: 50px;
						border-radius: 8px;
						background-color: #CDEB67;
						cursor: pointer;
					}
				}
				.pay_way_wrap {
					height: 150px;
					color: #000000;
					border-radius: 12px;
					border: 1px solid #E0E0E0;
					display: flex;
					align-items: center;
					overflow: hidden;
					.way_list {
						width: 150px;
						height: 100%;
						padding: 12px 0 0 10px;
						background-color: #F0F0F0;
						.title {
							font-size: 12px;
							color: rgba(0, 0, 0, 0.45);
						}
						.way_item {
							display: flex;
							align-items: center;
							font-size: 14px;
							height: 38px;
							margin-bottom: 11px;
							padding-left: 13px;
							cursor: pointer;
							.pay_icon {
								width: 30px;
								height: auto;
								margin-right: 6px;
							}
						}
						.active_way {
							font-weight: bold;
							border-radius: 8px 0 0 8px;
							background-color: #FFFFFF;
						}
					}
					.info_wrap {
						display: flex;
						align-items: center;
						padding-left: 70px;
						.qr_wrap {
							width: 110px;
							height: 110px;
							position: relative;
							margin-right: 20px;
							.qr_mark {
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								display: flex;
								align-items: center;
								justify-content: center;
								background-color: rgba(0, 0, 0, 0.9);
								cursor: pointer;
							}
						}
						.info {
							.info_title {
								font-size: 14px;
							}
							.price {
								font-size: 30px;
								color: #E28940;
								font-weight: bold;
								margin: 4px 0 14px;
							}
							.info_tips {
								font-size: 14px;
								color: #777777;
							}
						}
					}
				}
				.recharge_footer {
					display: flex;
					align-items: center;
					justify-content: center;
					margin-top: 20px;
					font-size: 14px;
					color: #777777;
					.qq_icon {
						width: 20px;
						height: 20px;
						margin: 0 6px 0 8px;
					}
					.qq {
						font-size: 16px;
						color: #000000;
					}
				}
				// .product_wrap::-webkit-scrollbar {
				// 	display: none;
				// }
			}
		}
	}
}
.mark_show {
	height: 100vh;
	overflow: hidden;
}

.logoHidden {
  position: relative;
  left: -500px; /* 调整 down 元素的位置，根据实际情况进行调整 */
}

</style>
